export const scrollSetup = ({color, shadow}) => `
    &::-webkit-scrollbar {
        background: ${color || 'none'};
        width: 6px;
        height: 6px;
        border-radius: 50px;
    }
    &::-webkit-scrollbar-track {
        background: ${color || 'none'};
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: ${shadow || 'none'};
        background: ${color || 'none'};
    }
`;
export const scrollNone = () => `
    &::-webkit-scrollbar {
        background: none;
        width: 0;
        height: 0;
        border-radius: 50px;
        padding-right: 2px;
    }
    &::-webkit-scrollbar-track {
        background: none;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: none;
        background: none;
    }
`;

export const scrollWhite = () => `
    &::-webkit-scrollbar {
        background: var(--scroll-bar-background);
        width: 12px;
        height: 12px;
        border-radius: 50px; 
    }

    &::-webkit-scrollbar-track {
        background: var(--scroll-bar-track-background);
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0px 0px 2px 1px rgba(38, 38, 38, 0.13);
        background: white;
        cursor: pointer;
    }
`;

export const scrollBody = () => `
    &::-webkit-scrollbar {
        background: var(--scroll-bar-background);
        width: 12px;
        height: 12px;
        border-radius: 50px; 
    }

    &::-webkit-scrollbar-track {
        background: var(--scroll-bar-track-background);
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: var(--scroll-bar-thumb);
        background: white;
        cursor: pointer;
    }
`;
